// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
    <sub-header header="'Stop orders'"></sub-header>

  <div class="tab-menu">
    <ul class="nav-tabs">
      <li ng-class="{'active': \$ctrl.displayMode === 'ACTIVE'}">
        <a data-target="#tab-active-stop-orders" data-toggle="tab" ng-click="\$ctrl.setDisplayMode('ACTIVE')">
          <span>Active</span>
        </a>
      </li>
      <li ng-class="{'active': false}" class="disabled">
        <a disabled>
          <span>Removed</span>
        </a>
      </li>
    </ul>
  </div>

  <active-stop-order-list ng-if="\$ctrl.displayMode === 'ACTIVE'"></active-stop-order-list>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/inventory/stop-order/stop-order-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;